/* eslint-disable */
import $ from "jquery";

const headerSearch = () => {
  const header = document.querySelector(".header-site-top");
  const searchToggle = document.querySelector(".search-toggle");
  const searchInput = document.getElementById("HeaderSearchForm");
  const body = document.querySelector("body");
  const icon = document.querySelector(".icon-search");
  const overlay = document.querySelector(".mobile-nav-overlay");
  const heroOverlay = document.querySelector(".hero-image-overlay");
  const accordionBtn = document.querySelectorAll(".toggle-accordion");
  const accordionButtons = [].slice.call(accordionBtn);
  const nav = document.querySelector(".nav--main-mobile");
  const searchField = document.querySelector(".searchfield");
  const submitBtn = document.querySelector(".search-btn");
  const deviceWidthSM = 990;

  /**
   * Show the site search for both mobile and desktop
   */
  const SearchShow = () => {
    body.classList.add("search-open");
    icon.classList.add("icon-search-active");
    overlay.classList.add("overlay-active");
    header.classList.add("header-search-active");
    if (heroOverlay) {
      heroOverlay.classList.add("overlay-active");
      heroOverlay.classList.add("overlay-index");
    }

    accordionButtons.forEach(e => {
      e.classList.add("accordion-overlay");
    });

    searchField.focus();
  };

  /**
   * Main function to hide the search window
   */
  const SearchHide = () => {
    body.classList.remove("search-open");
    icon.classList.remove("icon-search-active");
    nav.classList.remove("open");
    overlay.classList.remove("overlay-active");

    if (heroOverlay) {
      heroOverlay.classList.remove("overlay-active");
    }

    body.classList.remove("nav-active");
    header.classList.remove("header-search-active");

    searchInput.blur();

    setTimeout(() => {
      if (heroOverlay) {
        heroOverlay.classList.remove("overlay-index");
      }

      accordionButtons.forEach(e => {
        e.classList.remove("accordion-overlay");
      });
    }, 300);
  };

  const CloseSearch = el => {
    if (document.querySelector(".header-search")) {

      const clickInsideSearch = document
        .querySelector(".header-search")
        .contains(el.target);

      const suggestionIsSelected = document
        .querySelector("#header-search-autosuggest-list > li > button.suggestion-active") !== null

      if (!clickInsideSearch && !suggestionIsSelected) {
        setTimeout(() => {
          SearchHide();
        }, 500)

      }
    }
  };

  // Set up event handlers
  const bindEventHandlers = () => {
    // Main site search bar toggle
    if (searchToggle) {
      searchToggle.addEventListener("click", () => {
        if (header.classList.contains("header-search-active")) {
          setTimeout(() => {
            SearchHide();
          }, 500)

        } else {
          SearchShow();
        }
      });
    }

    // Hide the search for our main site desktop
    // If we tab away
    if (searchField && $(window).width() >= deviceWidthSM) {
      searchField.addEventListener("blur", el => {
        icon.classList.remove("icon-search-active");
        setTimeout(() => {
          CloseSearch(el);
        }, 500)

      });
    }

    searchInput.addEventListener("blur", () => {
      icon.classList.remove("icon-search-active");
    });

    searchInput.addEventListener("focus", () => {
      icon.classList.add("icon-search-active");
    });

    // Listen to click outside of search input
    // and close search
    body.addEventListener("click", el => {
      if (body.classList.contains("search-open")) {
        CloseSearch(el);
      }
    });

    // If we remove focus from the submit button close the search
    submitBtn.addEventListener("focusout", el => {
      icon.classList.remove("icon-search-active");
      CloseSearch(el.target);
    });
  }

  // Bind Event handlers when doc is ready
  $(document).ready(() => {
    bindEventHandlers();
  });

  // If selecting the skip links "jump to search"
  // toggle the search form
  $("#site-search").keydown(event => {
    if (event.which == 13) {
      event.preventDefault();
      if (header.classList.contains("header-search-active")) {
        setTimeout(() => {
          SearchHide();
        }, 500)

      } else {
        SearchShow();
      }
    }
  });
};

export default headerSearch;
/* eslint-enable */
